<template>
  <div>
    <div
      class="row et_row_complete text-center p-0 py-4 cpl-event col-12 col-md-6 m-auto"
    >
      <!-- event -->
      <div class="col-6">
        <div
          :title="store.state.selected_teampage.page.Event.EventName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="useImagePlugin().getImageWithResolution(store.state.selected_teampage.page.Event.EventImagePath,1000)"
            class="card-img-top img-fluid"
            alt=""
          />
        </div>
        <p>
          {{ store.state.selected_teampage.page.Event.EventName }}
        </p>
      </div>

      <!-- team name -->
      <div class="col-6">
        <div
          :title="store.state.selected_teampage.page.PageTitle"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="store.state.selected_teampage.page.ImagePath"
            class="card-img-top img-fluid"
            alt=""
          />
        </div>
        <p>
          {{ store.state.selected_teampage.page.PageTitle }}
        </p>
      </div>
    </div>
    <div class="col m-auto">
      <div class="gf-connect-fb">
        <template v-if="store.state.userLogon">          
          <div class="eb-pt-row-login">
            <div class="row justify-content-md-center mx-1 mt-3">
              <div class="col bgr-main ">
                <slot name="terms"></slot>
                <Logged />
              </div>                            
            </div>
          </div>          
        </template>
        <template v-else>
          <Loader :show="store.state.creatingPage"/>
          <GfLoginModule 
            :custom-container-class="'col'"
            :provider-details="providerDetails"
            :captcha-public-key="captchaPublicKey"
            :facebook="facebookAuth"
            @logged-in="$_createFundraisingPageMixin_onLoggedIn"
            :disable-redirect="true"
            :is-page-create="true"
            :register-url="registerUrl"
            template="tab"
          >
            <template #terms>
              <slot name="terms"></slot>
            </template>
          </GfLoginModule>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Logged from "../login/Logged.vue";
import CreateFundraisingPageMixin from "../inc/CreateFundraisingPageMixin.vue";
import useImagePlugin from "../../composables/useImagePlugin";
import { GfLoginModule } from '@gf/gf-login-vue-3' 
import Loader from '../inc/Loader.vue'

export default {
  components: {
    Logged,
    GfLoginModule,
    Loader,
  },

  mixins: [CreateFundraisingPageMixin],

  data() {
    return {
      useImagePlugin,
    }
  },

  async mounted() {
    (this.pageType = "S"),
      (this.teamId = this.store.state.selected_teampage.page.Id);
    this.charityId = this.store.state.selected_teampage.page.Beneficiary.BeneficiaryAccountId;
    this.eventCampaignId = this.store.state.selected_teampage.page.Event.EventCampaignId;

    try {
      await this.$_createFundraisingPageMixin_loadVueAnalytics();
    } catch (e) {
      console.log("Failed to load google Analytics.");
    }
  },
};
</script>
<style scoped>
.card-img-top.img-fluid {
  width: 100%;
  height: 8vw;
  object-fit: contain;
}
</style>
<style>
@import "../../assets/css/aws-amplify.css";
</style>